// extracted by mini-css-extract-plugin
module.exports = {"SubHeader":"SubHeader_SubHeader__yaAnf"};